import {useState, useEffect} from 'react';
import styles from '@/components/directory/v2/card-view/EVsCardItemVariantsManager.module.css';
import EVsCardItemVariantSkeleton from '@/components/ui/skeletons/EVsCardItemVariantSkeleton';
import EVsCardItemVariantsHeaderComponent from '@/components/directory/v2/card-view/EVsCardItemVariantsHeaderComponent';
import EVsCardItemVariantComponent from "@/components/directory/v2/card-view/EVsCardItemVariantComponent";

const EVsCardItemVariantsManager = ({variants}) => {
  const [sortedVariants, setSortedVariants] = useState([...variants]);

  const sortVariants = ({key, direction}) => {
    const sorted = [...variants].sort((a, b) => {
      let aValue, bValue;
      if (key === 'range' || key === 'charge_time' || key === 'speed') {
        aValue = a.data.attributes[key === 'range' ? 0 : key === 'charge_time' ? 1 : 2].value;
        bValue = b.data.attributes[key === 'range' ? 0 : key === 'charge_time' ? 1 : 2].value;
      } else if (key === 'year' || key === 'price' || key === 'status') {
        aValue = a.data[key];
        bValue = b.data[key];
      } else if (key === 'capacity') {
        aValue = a.data.basic_details[4].value;
        bValue = b.data.basic_details[4].value;
      }

      if (aValue < bValue) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
    setSortedVariants(sorted);
  };

  useEffect(() => {
    setSortedVariants([...variants]);
  }, [variants]);

  return (
    <div className={styles.container}>
      <EVsCardItemVariantsHeaderComponent onSort={sortVariants}/>
      <div className={styles.variants}>
        {sortedVariants.map((variant, index) => (
          <div key={index} className={styles.variant} style={{animationDelay: `${index * 0.1}s`}}>
            {variant.loading ? (
              <EVsCardItemVariantSkeleton/>
            ) : (
              <EVsCardItemVariantComponent variant={variant.data}/>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EVsCardItemVariantsManager;
